module.exports = __webpack_public_path__ + "static/media/Icons_language.1394090b.svg";